<template>
  <div>
    <v-dialog v-model="dialog" width="400" class="overwrite-dropzone-index">
      <template v-slot:activator="{ on, attrs }">
        <BtnWhite
          btnTitle="ACCÈS ADMIN"
          v-bind="attrs"
          v-on="on"
          @clicked="adminAccess"
        ></BtnWhite>
      </template>
      <v-card>
        <v-card-title class="text-h5 text-center"
          >ACCÈS ADMINISTRATEUR {{ selectedClient }}</v-card-title
        >
        <v-card-text class="d-flex justify-center">
          <Loading v-if="loading"></Loading>
          <a v-else class="admin-access-link" :href="adminURL" target="_blank"
            >ACCEDER</a
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BtnWhite from "./BtnWhite.vue";
import Loading from "./Loading.vue";

export default {
  name: "DialogAdminAccess",

  components: {
    BtnWhite,
    Loading,
  },

  data() {
    return {
      dialog: false,
      loading: false,
      adminURL: null,
    };
  },

  computed: {
    selectedClient() {
      return this.$store.getters.selectedClient.displayname;
    },
  },

  watch: {
    dialog(nVal) {
      if (!nVal) {
        this.adminURL = null;
      }
    },
  },

  methods: {
    async adminAccess() {
      console.log("adminAccess");
      this.dialog = true;
      this.loading = true;
      const url = await this.$store.dispatch("getAdminAccess");
      if (url == undefined) {
        this.dialog = false;
      } else if (url.startsWith("https://")) {
        this.adminURL = url;
        this.loading = false;
      } else {
        this.dialog = false;
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.admin-access-link {
  border: 1px solid grey;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-top: 1rem;
  color: #344767;
  text-decoration: none;
  font-weight: bold;
}
</style>
